












































































































import { defineComponent } from '@vue/composition-api';
import { trackEvent } from './../../../utils/index';
import AuthorizationVideoDetail from './authorization-video-detail.vue';
import TutorialPreview from './tutorial-preview.vue';
import { videoCodeValidator, fromVideoCodeValidator } from './validator';
import { useAuthorizePost } from '../hooks/use-authorize-post';

const STATES = {
  INIT: 1, // 初始状态
  FETCHED: 2, // 拉取到链接对应信息
  SUCCESS: 3, // 成功提交授权
};
const name = 'ttam-identity-tiktok-post-authorization';
export default defineComponent({
  name,
  components: {
    TutorialPreview,
    AuthorizationVideoDetail,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const {
      authorizationFormRef,
      authorizationForm,
      searchLoading,
      state,
      nativeVideo,
      videoCodeError,
      fromVideoCodeError,
      hasOriginalPost,
      isStateInit,
      isStateFetched,
      hasNativeVideo,
      title,
      videoCode,
      fromVideoCode,

      onClearCode,
      handleCreateAuthorization,
      getNativeVideoInfo,
      getFromNativeVideoInfo: _getFromNativeVideoInfo,
    } = useAuthorizePost();

    function close() {
      onClearCode();
      emit('update:visible', false);
    }

    function closeDialog() {
      trackEvent('close_apply_for_authorization');
      close();
    }

    function successClose() {
      const id = nativeVideo.value?.coreUserId || '';
      emit('success');
      if (id) {
        emit('authVideo', { id });
      }
      close();
    }
    function _handleCreateAuthorization() {
      handleCreateAuthorization({
        onSuccess: successClose,
      });
    }
    function getFromNativeVideoInfo() {
      _getFromNativeVideoInfo({
        onSuccess: successClose,
      });
    }

    return {
      name,
      STATES,

      state,
      title,
      videoCode,
      isStateInit,
      nativeVideo,
      fromVideoCode,
      searchLoading,
      videoCodeError,
      hasNativeVideo,
      isStateFetched,
      hasOriginalPost,
      fromVideoCodeError,
      videoCodeValidator,
      authorizationForm,
      authorizationFormRef,
      fromVideoCodeValidator,

      closeDialog,
      onClearCode,
      getNativeVideoInfo,
      getFromNativeVideoInfo,
      _handleCreateAuthorization,
    };
  },
});
